/**
 * VH-263: an ingredient amount at the precision a kitchen works in.
 *
 * Reto, 2026-09-24: "I have to round to one decimal manually before I can save a
 * recipe." The amount input carried step="0.1", and an HTML number input with a step
 * refuses any value that is not a multiple of it — so a scaled recipe arriving as
 * "0.11399999999999999 tsp" could not be saved until every such row was edited by hand.
 *
 * Its own module rather than an export from the form: a component file that also exports
 * a helper breaks fast refresh, which is a lint error here (CI, 2026-09-25).
 */

/** One decimal, keeping the smallest visible amount rather than rounding to nothing. */
export const roundAmount = (value) => {
  if (value === '' || value === null || value === undefined) return value
  const n = typeof value === 'string' ? parseFloat(value) : value
  if (Number.isNaN(n)) return value
  const rounded = Math.round(n * 10) / 10
  // An ingredient that is in the recipe must not silently leave it, and the backend
  // rejects 0 anyway.
  return rounded === 0 && n > 0 ? 0.1 : rounded
}
